import { AfterViewInit, Component, NgZone, OnInit } from "@angular/core";
import {
  NavController,
  NavParams,
  ModalController,
  AlertController,
  LoadingController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { GrupoCheckPessoaPage } from "../grupo-check-pessoa/grupo-check-pessoa.page";
import { GrupoProvider } from "src/app/services/grupo/grupo";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ImagePipe } from "src/app/pipes/image/image";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { Barcode, BarcodeScanner, LensFacing } from "@capacitor-mlkit/barcode-scanning";
import { BarcodeScanningModalComponent } from "src/app/components/barcode-scanning/barcode-scanning";
@Component({
  selector: "app-grupo-check-list",
  templateUrl: "./grupo-check-list.page.html",
  styleUrls: ["./grupo-check-list.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, ImagePipe, TranslateModule, SemRegistroComponent],
})
export class GrupoCheckListPage implements AfterViewInit, OnInit {
  cc: any = 0;
  filtro: any = { q: "", t: "inscritos", pessoa: "", isResponsavel: "0" };
  pagination: any = { currentPage: 0, pageCount: 0 };
  inscritosList: any = [];
  idReuniao: boolean = false;
  dependetesResponsavel: any = [];
  responsavelFiltrado: boolean = false;
  result: any;
  scanActive = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public modalCtrl: ModalController,
    public translate: TranslateService,
    public alertCtrl: AlertController,
    public loadingController: LoadingController,
    private readonly ngZone: NgZone
  ) {
    this.idReuniao = this.navParams.get("idReuniao");
    this.loadInscritos(null);
  }

  ngOnInit(): void {}

  ngAfterViewInit() {}

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  loadInscritos(infiniteScroll: { target: { complete: () => void } } | null) {
    this.pagination.currentPage++;

    this.grupoProvider.getParticipantesGeral(this.filtro, this.pagination, this.idReuniao).subscribe((res) => {
      this.inscritosList = this.inscritosList.concat(res.pessoas);
      this.pagination = res.pagination;

      if (infiniteScroll) infiniteScroll.target.complete();
    });
  }

  async selecionar(pessoa: any) {
    const modalPage = await this.modalCtrl.create({
      component: GrupoCheckPessoaPage,
      componentProps: { pessoa: pessoa, idReuniao: this.idReuniao },
    });
    modalPage.present();

    const data = await modalPage.onWillDismiss();
    if (this.responsavelFiltrado) {
      this.buscaPorResponsavel();
      this.filtro.isResponsavel = "0";
    }

    if (data) {
      this.inscritosList = [];
      this.pagination = { currentPage: 0, pageCount: 0 };
      this.filtro.pessoa = "";
      this.loadInscritos(null);
    }
  }

  onCancel() {
    this.inscritosList = [];
    this.filtro.q = "";
    this.loadInscritos(null);
    this.pagination = { currentPage: 0, pageCount: 0 };
  }

  onInput() {
    if (this.filtro.q.length >= 3) {
      this.inscritosList = [];
      this.pagination = { currentPage: 0, pageCount: 0 };
      this.loadInscritos(null);
    } else if (this.filtro.q.length == 0) {
      this.inscritosList = [];
      this.pagination = { currentPage: 0, pageCount: 0 };
      this.loadInscritos(null);
    }
  }

  async leitor() {
    try {
      await this.checkPermission();
      const formats = LensFacing.Back || [];
      const lensFacing = LensFacing.Back;

      const element = await this.modalCtrl.create({
        component: BarcodeScanningModalComponent,
        cssClass: "barcode-scanning-modal",
        showBackdrop: false,
        componentProps: {
          formats: formats,
          lensFacing: lensFacing,
          text: "Buscar Inscrito",
        },
      });
      element.present();

      element.onDidDismiss().then((result: any) => {
        const barcode: Barcode | undefined = result.data?.barcode;

        if (barcode?.displayValue) {
          const code = this.tratarCodigoScaneado(barcode?.displayValue);

          if (code) {
            this.filtro.pessoa = code;

            this.grupoProvider
              .getParticipantesGeral(this.filtro, this.pagination, this.idReuniao)
              .subscribe(async (data) => {
                data.pessoas?.length
                  ? this.selecionar(data.pessoas[0])
                  : await this.showAlert(this.translate.instant("A pessoa não está inscrita na reunião"));
              });
          } else {
            this.showAlert(this.translate.instant("Código Inválido"));
          }
        }
      });
    } catch (err) {
      await this.showAlert(this.translate.instant("Erro ao escanear o código."));
    }
  }

  buscaPorResponsavel() {
    this.grupoProvider
      .getParticipantesGeral(this.filtro, this.pagination, this.idReuniao)
      .subscribe(async (data) => {
        if (data.pessoas) {
          this.dependetesResponsavel = data.pessoas;
          this.responsavelFiltrado = true;
        } else {
          await this.showAlert(
            this.translate.instant(
              'A responsável não possui nenhum depedente inscrito na reunião'
            )
          );
        }
      });
  }

  async checkPermission() {
    BarcodeScanner.checkPermissions().then((result) => {
      if (result.camera != "granted") {
        return;
      }
    });

    BarcodeScanner.removeAllListeners().then(() => {
      BarcodeScanner.addListener("googleBarcodeScannerModuleInstallProgress", (event) => {
        this.ngZone.run(() => {
          const { state, progress } = event;
        });
      });
    });
  }

  async leitorResponsavel(): Promise<void> {
    await this.checkPermission();
    const formats = LensFacing.Back || [];
    const lensFacing = LensFacing.Back;

    const element = await this.modalCtrl.create({
      component: BarcodeScanningModalComponent,
      cssClass: "barcode-scanning-modal",
      showBackdrop: false,
      componentProps: {
        formats: formats,
        lensFacing: lensFacing,
        text: "Buscar Responsável",
      },
    });
    element.present();

    element.onDidDismiss().then((result: any) => {
      const barcode: Barcode | undefined = result.data?.barcode;

      if (barcode?.displayValue) {
        const code = this.tratarCodigoScaneado(barcode?.displayValue);

        if (code) {
          this.filtro.pessoa = code;
          this.filtro.isResponsavel = "1";
          this.buscaPorResponsavel();
        } else {
          BarcodeScanner.stopScan();
          this.showAlert(this.translate.instant("Código Inválido"));
        }
      }
    });
  }

  private async showAlert(msg: string) {
    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Erro"),
      message: msg,
      buttons: ["OK"],
    });
    await alert.present();
  }

  tratarCodigoScaneado(code: string) {
    code = code.replace(/'/g, '"');
    var aux = JSON.parse(code);
    if (aux.C) return aux.C;
    return false;
  }
}
